<template>
    <q-page padding>
        <div class="q-display-1 q-mb-md text-secondary">
            <q-icon name="far fa-broadcast-tower" class="q-mb-sm" /> {{ $t(title_webcasts) }}
        </div>

        <q-tabs v-model="tab" color="secondary" class="shadow-1">
            <q-tab slot="title" name="event_data" :label="$t('event_data')" />
            <q-tab slot="title" name="subscribers" :label="$t('subscribers')" v-show="showTab" />
            <q-tab slot="title" name="tests" :label="$t('tests')" v-show="showTab" />
            <!-- <q-tab slot="title" name="reaction_tests" :label="$t('reaction_tests')" v-show="showTab" v-if="selected_client_params.group_training_use_evaluations" /> -->
            <q-tab slot="title" name="support_material" :label="$t('support_materials')" v-show="showTab" />
            <q-tab slot="title" name="reaction_tests" :label="$t('reaction_tests')" v-show="showTab" />
            <q-tab slot="title" name="stream" :label="$t('stream')" v-if="showTab && show_stream" />
            <q-tab slot="title" name="chat_moderation" :label="$t('chat_moderation')" v-show="showTab && show_chat_moderation" />
            <q-tab slot="title" v-if="useReviews" name="comments" :label="$t('comments')" v-show="showTab" />

            <q-tab-pane name="event_data" class="q-px-lg q-pb-xl" keep-alive>
                <event-data @loadContent="loadContent" :manageWebcasts="permissions.webcasts_manage" />
            </q-tab-pane>

            <q-tab-pane name="subscribers" class="q-px-lg q-pb-xl" keep-alive>
                <subscribers :manageWebcasts="permissions.webcasts_manage" />
            </q-tab-pane>

            <q-tab-pane name="tests" class="q-px-lg q-pb-xl" keep-alive>
                <tests :manageWebcasts="permissions.webcasts_manage" />
            </q-tab-pane>

            <q-tab-pane name="support_material">
                <support-material :manageWebcasts="permissions.webcasts_manage"/>
            </q-tab-pane>

            <q-tab-pane name="reaction_tests" class="q-px-lg q-pb-xl" keep-alive>
                <reaction-tests :manageWebcasts="permissions.webcasts_manage" />
            </q-tab-pane>

            <q-tab-pane name="stream" class="q-px-lg q-pb-xl" keep-alive>
                <stream :id_webcast="id_webcast" />
            </q-tab-pane>

            <q-tab-pane name="chat_moderation" class="q-px-lg q-pb-xl">
                <chat-moderation :manageWebcasts="permissions.webcasts_manage" />
            </q-tab-pane>

            <q-tab-pane name="comments">
                <comments origin="webcast" />
            </q-tab-pane>
        </q-tabs>
    </q-page>
</template>

<script>
import { mapGetters } from 'vuex'
import EventData from 'components/admin/webcasts/EventData'
import ChatModeration from 'components/admin/webcasts/ChatModeration'
import Stream from 'components/admin/webcasts/Stream'
import Tests from 'components/admin/webcasts/TestsTab'
import ReactionTests from 'components/admin/webcasts/ReactionTests'
import Comments from 'components/admin/Comments'
import SupportMaterialTab from 'components/admin/webcasts/SupportMaterialTab'
import Subscribers from 'components/admin/webcasts/Subscribers'

export default {
    i18nOptions: { namespaces: [ 'custom', 'common', 'webcast', 'training', 'admin'] },

    data() {
        return {
            tab: 'event_data',
            id_webcast: null,
            show_stream: false,
            show_chat_moderation: false,
            permissions: {
                webcasts_manage: false,
            }
        }
    },

    components: {
        'event-data': EventData,
        'chat-moderation': ChatModeration,
        'stream': Stream,
        'tests': Tests,
        'reaction-tests': ReactionTests,
        'comments': Comments,
        'support-material': SupportMaterialTab,
        'subscribers': Subscribers
    },

    computed: {
        ...mapGetters({
            access_token: 'common/access_token',
            clients: 'params/clients',
            id_user_client_selected: 'common/id_user_client_selected',
            user_client_module_items: 'common/user_client_module_items',
        }),

        getHeader() {
            let headers = {}
            return headers = {
                headers: {
                    'content-type': 'application/json',
                    'authorization': 'Basic ' + btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
                    'authorization': 'Bearer ' + this.access_token
                }
            }
        },

        title_webcasts(){
			if (this.id_user_client_selected) {
				let obj = this.clients.find((obj) => { return obj.id === this.id_user_client_selected })
				if (obj) {
					return obj.title_webcasts === '' ? 'webinars' : obj.title_webcasts
				}
			}
        },

        showTab() {
            if (this.id_webcast != 0) return true
            else return false
        },

        useReviews() {
            let obj = this.clients.find((obj) => { return obj.id === this.id_user_client_selected })
            if(obj) return  obj.use_comments_webcast
            else return true
        },
    },

    methods: {
        loadContent(content) {
            if (content.webcast_type === 2) this.show_stream = true
            if (content.use_chat === true) this.show_chat_moderation = true
        },

        checkPermissions() {
            const client = this.user_client_module_items.find((obj) => { return obj.id === this.id_user_client_selected })
            if (client) {
                for (const [key, value] of Object.entries(this.permissions)) {
                    let obj = client.module_items.find(obj => obj.slug === key)
                    if (obj) {
                        this.permissions[key] = obj.permission
                    }
                }
            } else return
        },
    },

    beforeRouteUpdate (to, from, next) {
        this.id_webcast = to.params.id
        next()
    },

    created() {
        this.id_webcast = this.$route.params.id
        this.checkPermissions()
    }
}
</script>

<style>

</style>
